// @ts-nocheck
import {
  BankOutlined,
  CloseOutlined,
  DeleteOutlined,
  EditOutlined,
  FileTextOutlined,
  PlusOutlined,
  TeamOutlined,
  UploadOutlined,
  UserOutlined,
} from '@ant-design/icons'
import {
  Button,
  Col,
  DatePicker,
  Form,
  Input,
  Modal,
  Row,
  Space,
  Tag,
  Tooltip,
  Upload,
  message,
} from 'antd'
import { inject, observer } from 'mobx-react'
import React, { useEffect, useRef, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { blue, redPrimary } from '../../../color'
import { AvatarHasName } from '../../../components/Common/Avatar'
import RichEditor from '../../../components/RichEditor/RichEditor'
import SelectPeoplePopup from '../../../components/SelectPeoplePopup'
import { ASSIGNEE_TYPE } from '../../../constants'
import { SelectList } from '../InternalDocumentOutgoingDocCreatePage/InternalDocumentOutgoingDocCreatePageStyled'
import {
  FileAction,
  FileItem,
  SignDocumentList,
} from '../InternalDocumentSignDocDetailPage/InternalDocumentSignDocDetailPageStyled'
import SelectGroupPopup from './components/SelectGroupPopup'

const { Dragger } = Upload
const { RangePicker } = DatePicker

const FeedbackBoardCreate = ({
  handleCancel,
  isVisible,
  isCreate = false,
  selectPeopleStore,
  fileStore,
  FeedbackProcedureStore,
  fetchFeedback,
  setIsVisible,
  departmentStore,
}) => {
  const { getDepartmentList, departmentListHDQT } = departmentStore
  const {
    selectUserData,
    selectDepartmentData,
    selectGroupData,
    isVisibleSelectGroupPopup,
    setIsVisibleSelectGroupPopup,
    isVisibleSelectUserDepartmentPopup,
    setIsVisibleSelectUserDepartmentPopup,
    handleOpenSelectUserDepartmentPopup,
    handleCancelSelectUserDepartment,
    handleOpenSelectGroupPopup,
    handleCancelSelectGroup,
    originDepartmentWithUserList,
    allDataGroupList,
  } = selectPeopleStore
  const [form] = Form.useForm()
  const OPINION_REF = useRef()
  const BASIS_REF = useRef()
  const ATTACHED_REF = useRef()
  const OTHER_REF = useRef()
  const history = useHistory()
  const [fileList, setFileList] = useState([])
  const [fileId, setFileId] = useState()
  const [followerList, setFollowerList] = useState([])
  const [handlerList, setHandlerList] = useState([])
  const [combinerList, setCombinerList] = useState([])
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [opinionContent, setOpinionContent] = useState(null)
  const [basis, setBasis] = useState(null)
  const [attachedDocs, setAttachedDocs] = useState(null)
  const [otherContent, setOtherContent] = useState(null)

  const [editorContent, setEditorContent] = useState({
    opinionContent,
    basis,
    attachedDocs,
    otherContent,
  })

  useEffect(() => {
    ;(async () => {
      await selectPeopleStore.clearSelectUserData()
      await setFollowerList([])
      await setHandlerList([])
      await selectPeopleStore.clearSelected()
      await selectPeopleStore.getAllGroupList()
      await getDepartmentList()
    })()
  }, [])

  useEffect(() => {
    setHandlerList([
      ...selectUserData[ASSIGNEE_TYPE.HANDLER],
      ...selectDepartmentData[ASSIGNEE_TYPE.HANDLER],
      ...selectGroupData[ASSIGNEE_TYPE.HANDLER],
    ])
    setFollowerList([
      ...selectUserData[ASSIGNEE_TYPE.FOLLOWER],
      ...selectDepartmentData[ASSIGNEE_TYPE.FOLLOWER],
      ...selectGroupData[ASSIGNEE_TYPE.FOLLOWER],
    ])
  }, [selectUserData, selectDepartmentData, selectGroupData])

  // Handle form submission
  const onFinish = async values => {
    const { startDate, endDate } = values
    const otherContentData = otherContentRefs.current.map(ref => ({
      id: ref.id,
      content: ref.ref ? ref.ref.editor.getData() : '',
    }))
    setIsSubmitting(true)
    try {
      // Filter and prepare the file list
      const uploadFileList = fileList
        ? fileList
            .filter(
              (elem, index, fileList) =>
                fileList.findIndex(file => file.name === elem.name) === index
            )
            .map(file => file.originFileObj)
            .filter(file => file)
        : []

      // Prepare for batch uploading files
      const batchUploadArr = []
      uploadFileList.forEach(file => {
        const formData = new FormData()
        formData.append('file', file)
        batchUploadArr.push(fileStore.uploadFile(formData))
      })

      // Gather handler and manager data
      const handlerData = handlerList.map(el => ({
        assignee_code: el.id,
        assignee_type: el.assignee_type,
        permission: el.permission,
      }))

      const managerData = followerList.map(el => ({
        assignee_code: el.id,
        assignee_type: el.assignee_type,
        permission: 'VIEW',
      }))
      if (endDate.isBefore(startDate)) {
        return message.info('Ngày kết thúc phải lớn hơn ngày bắt đầu!')
      }

      // Validation checks
      if (managerData.length === 0) {
        return message.info('Bạn chưa chọn Người theo dõi!')
      }
      if (handlerData.length === 0) {
        return message.info('Bạn chưa chọn người xử lý !')
      }

      // Handle file uploads (await all uploads to finish)
      const uploadResponses = await Promise.all(batchUploadArr)

      // Collect all file IDs from upload responses
      const fileIds = uploadResponses.map(response => response.data.file_id)

      // Add the sign document file ID if necessary, only if it hasn't been uploaded
      const firstFile = fileList[0]?.originFileObj
      if (firstFile && !fileIds.includes(uploadResponses[0]?.data?.file_id)) {
        const formData = new FormData()
        formData.append('file', firstFile)
        const responseSignDoc = await fileStore.uploadFile(formData)
        if (responseSignDoc.data.file_id) {
          fileIds.push(responseSignDoc.data.file_id)
        }
      }

      const submitData = {
        title: values.title,
        // content: OPINION_REF?.current?.editor.getData(),
        startDate: startDate.format('DD-MM-YYYY'),
        endDate: endDate.format('DD-MM-YYYY'),
        legalBasis: BASIS_REF?.current?.editor.getData(),
        attachedDocuments: ATTACHED_REF?.current?.editor.getData(),
        otherContent: OTHER_REF?.current?.editor.getData(),
        feedbackComments: otherContentData
          .filter(item => item.content !== '')
          .map(item => ({ content: item.content })),
        status: 'DISAGREED',
        fileIdAttachment: fileIds,
        assignees: [...handlerData, ...managerData],
      }

      // console.log(submitData)

      // Make API call to submit the form data
      const response = await FeedbackProcedureStore.createElectronicDocument(
        submitData
      )
      // Handle success or error messages
      if (response.status === 200) {
        setIsVisible(false)
        message.success('Tạo phiếu lấy ý kiến thành công!')
        form.resetFields()

        setOpinionContent(null)
        setBasis(null)
        setAttachedDocs(null)
        setOtherContent(null)
        setFileList([])
        setFollowerList([])
        setHandlerList([])
        selectPeopleStore.clearSelectUserData()
        selectPeopleStore.clearSelectDepartmentData()
        selectPeopleStore.clearSelectedHandlerAndFollower()
        fetchFeedback()
      } else {
        console.error('Error in form submission:', response)
      }
    } catch (error) {
      console.error('Error in form submission:', error)
    } finally {
      setIsSubmitting(false)
    }
  }

  // Function to update the editor content in state
  const handleEditorChange = (field, content) => {
    // console.log(`Field: ${field}, Content: ${content}`)
    setEditorContent(prevState => ({
      ...prevState,
      [field]: content, // Cập nhật giá trị cho field tương ứng
    }))
  }
  const handleChangeFile = info => {
    if (info.fileList.length === 0) {
      form.setFieldsValue({
        file_upload: undefined,
      })
      setFileList([])
      return
    }
    const filteredFileList = info.fileList.filter(
      (elem, index, fileList) =>
        fileList.findIndex(file => file.name === elem.name) === index
    )
    setFileList(filteredFileList)
  }

  const otherContentRefs = useRef([])
  const [otherContentList, setOtherContentList] = useState([
    { id: 1, content: null },
  ])

  const handleOtherContentChange = (id, content) => {
    setOtherContentList(prevList =>
      prevList.map(item => (item.id === id ? { ...item, content } : item))
    )
  }

  const handleAddOtherContent = () => {
    const newContent = { id: Date.now(), content: '' }
    setOtherContentList(prevList => [...prevList, newContent])
  }

  const handleRemoveOtherContent = id => {
    setOtherContentList(prevList => {
      const updatedList = prevList.filter(item => item.id !== id)
      return updatedList
    })

    otherContentRefs.current = otherContentRefs.current.filter(
      ref => ref.id !== id
    )
  }
  return (
    <>
      <Modal
        width={800}
        style={{ top: 40, zIndex: 500 }}
        title={'Tạo mới quy trình lấy ý kiến'}
        visible={isVisible}
        maskClosable={false}
        onCancel={handleCancel}
        footer={null}>
        <Form
          form={form}
          layout="vertical"
          onFinish={onFinish}
          style={{ maxWidth: '800px', margin: '0 auto' }}>
          <Form.Item
            label="Tiêu đề"
            name="title"
            rules={[{ required: true, message: 'Vui lòng nhập tiêu đề!' }]}>
            <Input placeholder="Nhập tiêu đề" />
          </Form.Item>

          {/* <Form.Item label="Nội dung lấy ý kiến" name="opinionContent">
            <RichEditor
              EDITOR_REF={OPINION_REF}
              editorContent={opinionContent}
              height={200}
            />
          </Form.Item> */}
          <Form.Item label="Nội dung lấy ý kiến">
            {otherContentList.map((item, index) => (
              <div
                key={item.id}
                style={{ position: 'relative', marginBottom: '16px' }}>
                <RichEditor
                  EDITOR_REF={el => {
                    // Cập nhật tham chiếu vào ref
                    otherContentRefs.current[index] = { id: item.id, ref: el }
                  }}
                  editorContent={item.content}
                  height={100}
                  onChange={content =>
                    handleOtherContentChange(item.id, content)
                  }
                />
                {otherContentList.length > 1 && (
                  <Button
                    type="text"
                    icon={<DeleteOutlined style={{ color: 'red' }} />}
                    onClick={() => handleRemoveOtherContent(item.id)}
                    style={{ position: 'absolute', top: '0', right: '-27px' }}
                  />
                )}
              </div>
            ))}
            <Button
              type="dashed"
              icon={<PlusOutlined />}
              onClick={handleAddOtherContent}
              style={{ width: '100%', marginTop: '10px' }}>
              Thêm nội dung ý kiến khác
            </Button>
          </Form.Item>

          <Row gutter={[16, 16]}>
            <Col span={12}>
              <Form.Item
                label="Ngày bắt đầu"
                name="startDate"
                rules={[
                  { required: true, message: 'Vui lòng nhập ngày bắt đầu!' },
                ]}>
                <DatePicker format={'DD/MM/YYYY'} style={{ width: '100%' }} />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label="Ngày kết thúc"
                name="endDate"
                rules={[
                  { required: true, message: 'Vui lòng nhập ngày kết thúc!' },
                ]}>
                <DatePicker format={'DD/MM/YYYY'} style={{ width: '100%' }} />
              </Form.Item>
            </Col>
          </Row>

          <Form.Item label="Các căn cứ" name="basis">
            <RichEditor
              EDITOR_REF={BASIS_REF}
              editorContent={basis}
              height={100}
            />
          </Form.Item>

          <Form.Item label="Tài liệu kèm theo" name="attachedDocs">
            <RichEditor
              EDITOR_REF={ATTACHED_REF}
              editorContent={attachedDocs}
              height={50}
            />
          </Form.Item>

          <Form.Item label="Nội dung khác" name="otherContent">
            <RichEditor
              EDITOR_REF={OTHER_REF}
              editorContent={otherContent}
              height={100}
            />
          </Form.Item>

          <Form.Item label={'Tài liệu kèm theo:'} name={'file'}>
            <Upload
              valuePropName={'fileList'}
              fileList={fileList}
              multiple={true}
              beforeUpload={() => false}
              onChange={handleChangeFile}
              showUploadList={false}>
              <Button icon={<UploadOutlined />}>Chọn tài liệu kèm theo</Button>
            </Upload>
            <SignDocumentList>
              {fileList.map((file, _) => {
                return (
                  <FileItem key={file.uid}>
                    <span>
                      <FileTextOutlined style={{ marginRight: 5 }} />
                      {file.name}
                    </span>
                    <FileAction>
                      <Tooltip title={'Xóa'}>
                        <Button
                          type={'text'}
                          icon={
                            <DeleteOutlined style={{ color: redPrimary }} />
                          }
                          onClick={() =>
                            setFileList(
                              fileList.filter(el => el.uid !== file.uid)
                            )
                          }
                        />
                      </Tooltip>
                    </FileAction>
                  </FileItem>
                )
              })}
            </SignDocumentList>
          </Form.Item>
          <Row gutter={[16, 16]}>
            <Col span={12}>
              <label
                style={{ display: 'inline-block', margin: '15px 12px 25px 0' }}>
                <span style={{ color: redPrimary, margin: '0 1px' }}>*</span>
                Người xử lý:
              </label>
              <Space>
                <Tooltip title="Chọn người dùng" color={blue}>
                  <Button
                    icon={<UserOutlined style={{ color: blue }} />}
                    onClick={() =>
                      handleOpenSelectUserDepartmentPopup(ASSIGNEE_TYPE.HANDLER)
                    }
                  />
                </Tooltip>
              </Space>
              <SelectList>
                {handlerList.map(el => (
                  <Tag
                    className={'tag-selected'}
                    color={'blue'}
                    key={el.id}
                    closable
                    onClose={() => selectPeopleStore.handleRemoveSelect(el)}>
                    <AvatarHasName
                      imgId={el.image_id}
                      size={22}
                      name={el.full_name}
                      icon={
                        (el.assignee_type === ASSIGNEE_TYPE.DEPARTMENT && (
                          <BankOutlined />
                        )) ||
                        (el.assignee_type === ASSIGNEE_TYPE.GROUP && (
                          <TeamOutlined />
                        ))
                      }
                    />
                  </Tag>
                ))}
              </SelectList>
            </Col>
            <Col span={12}>
              <label
                style={{ display: 'inline-block', margin: '15px 12px 25px 0' }}>
                <span style={{ color: redPrimary, margin: '0 3px' }}>*</span>Ý
                kiến của Ban Kiểm Soát và Các Tiểu Ban:
              </label>
              <Space>
                <Tooltip title="Chọn người dùng" color={blue}>
                  <Button
                    icon={<UserOutlined style={{ color: blue }} />}
                    onClick={() =>
                      handleOpenSelectGroupPopup(ASSIGNEE_TYPE.FOLLOWER)
                    }
                  />
                </Tooltip>
              </Space>
              <SelectList>
                {followerList.map(el => (
                  <Tag
                    className={'tag-selected'}
                    color={'blue'}
                    key={el.id}
                    closable
                    onClose={() => selectPeopleStore.handleRemoveSelect(el)}>
                    <AvatarHasName
                      imgId={el.image_id}
                      size={22}
                      name={el.full_name}
                      icon={
                        (el.assignee_type === ASSIGNEE_TYPE.DEPARTMENT && (
                          <BankOutlined />
                        )) ||
                        (el.assignee_type === ASSIGNEE_TYPE.GROUP && (
                          <TeamOutlined />
                        ))
                      }
                    />
                  </Tag>
                ))}
              </SelectList>
            </Col>
          </Row>
          <Form.Item
            style={{
              margin: 0,
              width: '100%',
              marginTop: '15px',
            }}>
            <div style={{ display: 'flex', justifyContent: 'flex-start' }}>
              <Button
                danger
                icon={<CloseOutlined />}
                style={{ marginLeft: '10px' }}
                onClick={handleCancel}>
                Hủy bỏ
              </Button>
            </div>
            <div
              style={{
                display: 'flex',
                justifyContent: 'flex-end',
                marginTop: '-30px',
              }}>
              <Button
                icon={<EditOutlined />}
                style={{ marginLeft: '10px' }}
                onClick={() => form.resetFields()}>
                Nhập lại
              </Button>
              <Button
                icon={<PlusOutlined />}
                type="primary"
                htmlType="submit"
                style={{ marginLeft: '10px' }}
                disabled={isSubmitting}>
                Tạo mới
              </Button>
            </div>
          </Form.Item>
        </Form>
      </Modal>
      <SelectPeoplePopup
        onlyOneUser={
          selectPeopleStore.assigneePopupType === ASSIGNEE_TYPE.LEADER
        }
        handleCancelSelectUser={handleCancelSelectUserDepartment}
        handleSubmitSelectUser={() =>
          setIsVisibleSelectUserDepartmentPopup(false)
        }
        isVisibleSelectPeoplePopup={isVisibleSelectUserDepartmentPopup}
        departmentType={
          selectPeopleStore.assigneePopupType === ASSIGNEE_TYPE.HANDLER
            ? departmentListHDQT.code
            : ''
        }
      />
      <SelectGroupPopup
        width={800}
        isFeedback={true}
        onlySelectOne={false}
        onlySelectUser={false}
        isVisibleSelectGroupPopup={isVisibleSelectGroupPopup}
        handleCancelSelectGroup={handleCancelSelectGroup}
        handleSubmitSelectGroup={() => setIsVisibleSelectGroupPopup(false)}
      />
    </>
  )
}

export default inject(
  'loadingAnimationStore',
  'selectPeopleStore',
  'fileStore',
  'FeedbackProcedureStore',
  'departmentStore'
)(observer(FeedbackBoardCreate))
